import React, { useEffect, useRef } from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { ReactComponent as CloseIcon } from '../../assets/images/icons/mevo/ic-exit-rounded-purple.svg';
import { ReactComponent as AlertIcon } from '../../assets/images/psp/alert.svg';
import { ReactComponent as AllegrilIcon } from '../../assets/images/psp/allegril.svg';
import { Button } from '../UI-CHAKRA/Button';
import { WHATSAPP_PBM_SIDEBAR_TITLE } from './constants';

interface WhatsappPbmFeedbackStepProps {
  status: 'success' | 'error';
  onClose: () => void;
  onRetry?: () => void;
  onEventEmission: (eventName: string, eventData: Record<string, unknown>) => void;
}

const CONTENT = {
  success: {
    Icon: AllegrilIcon,
    title: 'Boas notícias!',
    description: 'O paciente receberá as informações sobre o desconto. Para finalizar, basta emitir a prescrição.',
  },
  error: {
    Icon: AlertIcon,
    title: 'Não foi possível registrar o consentimento',
    description:
      'Tivemos uma instabilidade e o consentimento não foi salvo, então o paciente não receberá as informações sobre o desconto. Tente novamente ou siga com a emissão da receita normalmente.',
  },
};

const WhatsappPbmFeedbackStep: React.FC<WhatsappPbmFeedbackStepProps> = ({
  status,
  onClose,
  onRetry,
  onEventEmission,
}) => {
  const hasEmittedViewEventRef = useRef(false);
  const { Icon, title, description } = CONTENT[status];

  useEffect(() => {
    if (hasEmittedViewEventRef.current) return;
    hasEmittedViewEventRef.current = true;
    onEventEmission('backoffice_campaign_pbm_consent_click', {
      flow: 'consentimento',
      concluiuPreCadastro: status === 'success',
      statusEnvio: status,
    });
  }, [onEventEmission, status]);

  return (
    <Flex flexDirection={'column'} height={'100%'} overflow="hidden">
      {/* Sem layout mobile com "Voltar": nesta etapa não há para onde voltar, só fechar (mesmo padrão do PBM e do PSP). */}
      <Box flexShrink={0} borderBottom={'1px solid #E9ECEF'}>
        <Flex flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'} padding={'20px'}>
          <Text fontSize={'18px'} fontWeight={700} color={'#343A40'}>
            {WHATSAPP_PBM_SIDEBAR_TITLE}
          </Text>
          <CloseIcon onClick={onClose} cursor={'pointer'} />
        </Flex>
      </Box>

      <Box flexGrow={1} overflowY={'auto'} overflowX="hidden" padding={'120px 20px 20px 20px'}>
        <Flex flexDirection={'column'} alignItems={'center'} justifyContent={'center'} gap={'24px'} minH={'400px'}>
          <Box
            width={'150px'}
            height={'150px'}
            borderRadius={'50%'}
            display={'flex'}
            alignItems={'center'}
            justifyContent={'center'}
          >
            <Icon width={'150px'} height={'150px'} />
          </Box>

          <Text fontSize={'32px'} fontWeight={700} color={'primary.main'} textAlign={'center'}>
            {title}
          </Text>

          <Text fontSize={'14px'} color={'#3D0E6B'} textAlign={'center'} maxW={'400px'}>
            {description}
          </Text>
        </Flex>
      </Box>

      <Box flexShrink={0} padding={'20px'} borderTop={'1px solid #E9ECEF'}>
        <Flex flexDirection={'row'} gap={'12px'} justifyContent={'flex-end'}>
          <Button
            onClick={onClose}
            padding="10px 20px"
            backgroundColor={'#FFF'}
            borderWidth={'2px'}
            borderColor={'primary.main'}
            borderStyle={'solid'}
            borderRadius={'20px'}
            _hover={{ backgroundColor: '#FFF', borderColor: '#6B409C' }}
          >
            <Text fontSize={'14px'} color={'primary.main'}>
              Fechar
            </Text>
          </Button>
          {status === 'error' && onRetry && (
            <Button
              onClick={onRetry}
              padding="10px 20px"
              backgroundColor={'primary.main'}
              borderRadius={'20px'}
              color={'#FFF'}
              fontSize={'14px'}
              _hover={{ backgroundColor: '#6B409C' }}
            >
              Tentar novamente
            </Button>
          )}
        </Flex>
      </Box>
    </Flex>
  );
};

export default WhatsappPbmFeedbackStep;
